var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"terms"}},[(!_vm.loading)?_c('section',{staticClass:"content"},[_c('div',{attrs:{"id":"cgv"},domProps:{"innerHTML":_vm._s(_vm.terms)}})]):_c('loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }